import React from "react";
import MuiGlobalStyles from "@mui/material/GlobalStyles";
import PropTypes from "prop-types";

/**
 * GlobalStyles component wrapper for applying global styles.
 * Wraps Material-UI GlobalStyles with theme integration.
 * 
 * @component
 * @example
 * <GlobalStyles styles={{ body: { margin: 0 } }} />
 * 
 * @example
 * <GlobalStyles styles={(theme) => ({ body: { color: theme.palette.text.primary } })} />
 */
const GlobalStyles = ({ styles, ...props }) => {
  return <MuiGlobalStyles styles={styles} {...props} />;
};

GlobalStyles.propTypes = {
  /**
   * The styles you want to apply globally.
   * Can be an object or a function that receives the theme
   */
  styles: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
  ]).isRequired,
};

export default GlobalStyles;
